import React, { Component } from "react";
import { fetchAPINames } from "./api/APINamesFetcher";

export default class RenderApiNames extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiNames: [],
      serverResponseReceived: false,
      badResponseReceived: false,
      loading: false
    };
  }

  componentDidMount() {
    console.log("in RenderApiNames componentDidMount");
    this.setState({
      loading: true
    });
    fetchAPINames().then(data => {
      console.log("received response from fetchAPINames ", data);
      if (data.status === "INTERNAL_SERVER_ERROR") {
        this.setState({
          badResponseReceived: true,
          loading: false
        });
      } else {
        this.setState({
          apiNames: data,
          serverResponseReceived: true,
          loading: false
        });
      }
    });
  }

  render() {
    return (
      <div className="col-12">
        {this.state.badResponseReceived && (
          <div className="card-text-wrapper">
            <p className="card-text" id="serverError">
              There was an error retrieving your APIs.
            </p>
          </div>
        )}
        {this.state.serverResponseReceived &&
          this.state.apiNames &&
          this.state.apiNames.length === 0 && (
            <div className="card-text-wrapper">
              <p className="card-text" id="noResults">
                No APIs assigned.
              </p>
            </div>
          )}
        {this.state.loading && (
          <div>
            <i className="fa fa-refresh fa-spin" /> Loading...
          </div>
        )}

        {this.state.serverResponseReceived &&
          this.state.apiNames &&
          this.state.apiNames.length > 0 && (
            <div>
              <div className="card-text-wrapper">
                <ul>
                  {this.state.apiNames.map((name, index) => (
                    <li key={index}>{name}</li>
                  ))}
                </ul>
              </div>

              <div className="link-wrapper">
                <a
                  href="/developer/mvc/manageMyAccount#/myApis"
                  className="card-link"
                >
                  View full list of your APIs &gt;
                </a>
              </div>
            </div>
          )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/manageMyAccount/RenderApiNames.js